import React, { FunctionComponent, useState, useEffect, useCallback } from "react"
import toastMessages from "stores/toastMessages"

import Text from "components/Text/Text"

import "./ToastMessage.scss"
import { IMessage } from "models/Message"

interface IToastMessageProps {
    message: IMessage
}

const ToastMessage: FunctionComponent<React.PropsWithChildren<IToastMessageProps>> = ({ message }) => {
    const [isVisible, setIsVisible] = useState(false)

    const handleClose = useCallback(() => {
        toastMessages.hide(message)
    }, [message])

    useEffect(() => {
        setIsVisible(true)
    }, [])

    useEffect(() => {
        let timeoutInstance;
        if (message.duration && message.duration > 0) {
            timeoutInstance = setTimeout(() => handleClose(), message.duration)
        }
        return () => clearTimeout(timeoutInstance)
    }, [handleClose, message.duration])

    return (
        <div
            className={`toast-message toast-message--${message.type} ${isVisible ? 'toast-message--visible' : ''}`}
            role="status"
            aria-label="close"
            onClick={handleClose}
            data-testid="toast-message">
            {!!message.title &&
                <Text type="h4" data-testid="toast-message-title">{message.title}</Text>
            }
            {!!message.descr &&
                <Text className={message.title ? "mt-1" : ""} data-testid="toast-message-descr">{message.descr}</Text>
            }
        </div>
    )
}

export default ToastMessage
